import { History, RotateCw, Trash2 } from "lucide-react";

const KEY = "at_tc_recent";

// Session-only history; stores direction/zone/date/time + a summary — never personal data.
export function readRecent() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch { return []; }
}

export function pushRecent(entry) {
    const list = [entry, ...readRecent().filter((e) => e.key !== entry.key)].slice(0, 10);
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch { /* storage full / disabled */ }
    return list;
}

export function RecentConversions({ items, onReuse, onClear }) {
    if (!items.length) return null;
    return (
        <div className="bg-white border border-slate-200 rounded-2xl p-4" data-testid="tc-recent">
            <div className="flex items-center justify-between mb-2">
                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500 inline-flex items-center gap-1.5">
                    <History className="w-3.5 h-3.5" /> Recent conversions (this session)
                </div>
                <button type="button" onClick={onClear} data-testid="tc-recent-clear" className="text-xs text-slate-500 hover:text-rose-600 inline-flex items-center gap-1">
                    <Trash2 className="w-3.5 h-3.5" /> Clear
                </button>
            </div>
            <ul className="divide-y divide-slate-100">
                {items.map((e, i) => (
                    <li key={e.key} className="py-2 flex items-center gap-3" data-testid={`tc-recent-item-${i}`}>
                        <span className="flex-1 min-w-0 text-xs text-slate-700 break-words">{e.summary}</span>
                        <button type="button" onClick={() => onReuse(e)} data-testid={`tc-recent-reuse-${i}`}
                            className="shrink-0 inline-flex items-center gap-1 text-xs font-bold text-[#1E3A8A] px-2 py-1 rounded-md border border-slate-200 hover:border-[#1E3A8A]">
                            <RotateCw className="w-3 h-3" /> Reuse
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
